
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mynews/[[...pathParams]]",
      function () {
        return require("private-next-pages/mynews/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mynews/[[...pathParams]]"])
      });
    }
  